import { createAction, props } from '@ngrx/store';

export const OpenSideNav = createAction('[Layout] Open sidenav');
export const CloseSidenav = createAction('[Layout] Close sidenav');
export const ToggleSidenav = createAction('[Layout] Toggle sidenav');
export const OpenHelp = createAction('[Layout] Open help');
export const CloseHelp = createAction('[Layout] Close help');
export const ToggleHelp = createAction('[Layout] Toggle help');
